import { enumToObject } from '@feathr/hooks';

import type { IBreadcrumb } from './breadcrumbs.attributes';
import type { EFlavorsRaw, EReportFlavorsRaw } from './breadcrumbs.flavors';
import { EFlavors } from './breadcrumbs.flavors';

/** Person custom data */
export interface ICustomData {
  [key: string]: string | string[] | number | boolean | undefined;
}

/** UTM tracking parameters */
export interface IUTMParams {
  /** Specific campaign name or identifier */
  utm_campaign: string;
  /** Marketing medium
   * ex. email, CPC
   */
  utm_medium: string;
  /** Traffic source
   * ex. Google, Facebook
   */
  utm_source: string;
  /** Paid search keywords that triggered ad */
  utm_term: string;
  /** Differentiates content versions for A/B testing */
  utm_content: string;
}

/** Geographic location data */
export interface ILocation {
  latitude?: number;
  longitude?: number;
  /** Metropolitan area code */
  metro_code?: number;
  time_zone?: string;
}

export type FlavorKeys = keyof typeof EFlavorsRaw;
export type ReportFlavorKeys = keyof typeof EReportFlavorsRaw;

export const Flavors = enumToObject(EFlavors);
export type Flavors = typeof Flavors;

type TUserIdentifiers = Pick<IBreadcrumb, 'ttd_id' | 'uid2' | 'daid'>;
export type TUserIdentifierKeys = keyof TUserIdentifiers;
